import { ExportPanel } from '../components/ExportPanel';
import type { AnalysisResult } from '../domain/models';

export function ExportPage({ result }: { result: AnalysisResult }) {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Export</h1>
          <p className="page-subtitle">CSV / GeoJSON / Markdown をブラウザ内で生成します。</p>
        </div>
      </header>
      <ExportPanel result={result} />
    </div>
  );
}
